import { render } from "./ResizeVolume.vue?vue&type=template&id=276e0e2c&scoped=true"
import script from "./ResizeVolume.vue?vue&type=script&lang=js"
export * from "./ResizeVolume.vue?vue&type=script&lang=js"

import "./ResizeVolume.vue?vue&type=style&index=0&id=276e0e2c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276e0e2c"]])

export default __exports__